// extracted by mini-css-extract-plugin
export default {"fr-view":"Questions_fr-view__vqG4v","question":"Questions_question__44EU7"};